// Generated by CoffeeScript 1.4.0
var drawTable, getContentClass, head, isLeafObject, isLeafValue, isPlainObject, isTable, makeLabelDiv, render, toggleJS, _,
  __hasProp = {}.hasOwnProperty;

_ = require("underscore");

toggleJS = function(options) {
  if (options != null ? options.plainHtml : void 0) {
    return "";
  } else {
    return "onclick=\"j2h.toggleVisibility(this);return false\"";
  }
};

makeLabelDiv = function(options, level, keyname, datatype) {
  if (_.isNumber(keyname)) {
    return "<div class='index'><span class='j2hlabel'>" + keyname + "&nbsp;</span></div>";
  } else if (_.isString(keyname)) {
    if (datatype === 'array') {
      return "<div class='collapsible level" + level + "' " + (toggleJS(options)) + "><span class='j2hlabel'>" + keyname + "</span></div>";
    } else if (datatype === 'object') {
      return "<div class='attribute collapsible level" + level + "' " + (toggleJS(options)) + "><span class='j2hlabel'>" + keyname + ":</span></div>";
    } else {
      return "<div class='leaf level" + level + "'><span class='j2hlabel'>" + keyname + ":</span></div>";
    }
  } else {
    return "";
  }
};

getContentClass = function(keyname) {
  if (_.isString(keyname)) {
    return "content";
  } else {
    return "";
  }
};

isPlainObject = function(val) {
  var key, lastKey, lastOwnKey;
  for (key in val) {
    if (!__hasProp.call(val, key)) continue;
    lastOwnKey = key;
  }
  for (key in val) {
    lastKey = key;
  }
  return lastOwnKey === lastKey;
};

isLeafValue = function(val) {
  return _.isNumber(val) || _.isString(val) || _.isBoolean(val) || _.isDate(val) || _.isNull(val) || _.isUndefined(val) || _.isNaN(val) || _.isFunction(val) || !isPlainObject(val);
};

isLeafObject = function(obj) {
  var key, val;
  if (!_.isObject(obj)) {
    return false;
  }
  for (key in obj) {
    val = obj[key];
    if (!isLeafValue(val)) {
      return false;
    }
  }
  return true;
};

isTable = function(arr) {
  var cols, nonCompliant;
  if (!_.isArray(arr)) {
    return false;
  }
  if (arr.length === 0 || !_.isObject(arr[0])) {
    return false;
  } else {
    nonCompliant = _.detect(arr, function(row) {
      return !isLeafObject(row);
    });
    if (nonCompliant) {
      return false;
    } else {
      cols = _.keys(arr[0]);
      nonCompliant = _.detect(arr, function(row) {
        return !_.isEqual(cols, _.keys(row));
      });
      if (nonCompliant) {
        return false;
      } else {
        return true;
      }
    }
  }
};

drawTable = function(arr) {
  var cols, content, contentHtml, drawRow, headingHtml, rowObj;
  drawRow = function(headers, rowObj) {
    var header;
    return "<td>" + ((function() {
      var _i, _len, _results;
      _results = [];
      for (_i = 0, _len = headers.length; _i < _len; _i++) {
        header = headers[_i];
        _results.push(rowObj[header]);
      }
      return _results;
    })()).join("</td><td>") + "</td>";
  };
  cols = _.keys(arr[0]);
  content = (function() {
    var _i, _len, _results;
    _results = [];
    for (_i = 0, _len = arr.length; _i < _len; _i++) {
      rowObj = arr[_i];
      _results.push(drawRow(cols, rowObj));
    }
    return _results;
  })();
  headingHtml = "<tr><th>" + cols.join("</th><th>") + "</th></tr>";
  contentHtml = "<tr>" + content.join("</tr><tr>") + "</tr>";
  return "<table>" + headingHtml + contentHtml + "</table>";
};

render = function(name, data, options, level, altrow) {
  var contentClass, count, idx, inner, key, subs, title, val;
  contentClass = getContentClass(name);
  if (_.isArray(data)) {
    title = makeLabelDiv(options, level, "" + name + " (" + data.length + ")", 'array');
    if (isTable(data)) {
      subs = drawTable(data);
    } else {
      subs = "<div class='altRows'>" + ((function() {
        var _i, _len, _results;
        _results = [];
        for (idx = _i = 0, _len = data.length; _i < _len; idx = ++_i) {
          val = data[idx];
          _results.push(render(idx, val, options, level + 1, idx % 2));
        }
        return _results;
      })()).join("</div><div class='altRows'>") + "</div>";
    }
    return "		<div class=\"j2hcollapse clearfix " + altrow + "\">			" + title + "			<div class=\"" + contentClass + "\">" + subs + "</div>		</div>";
  } else if (isLeafValue(data)) {
    title = makeLabelDiv(options, level, name);
    if (_.isFunction(data)) {
      return "" + title + "<span class='j2hvalue'>&nbsp;&nbsp;-function() can't render-</span>";
    } else if (!isPlainObject(data)) {
      if (_.isFunction(data.toString)) {
        return "" + title + "<span class='j2hvalue'>&nbsp;&nbsp;" + (data.toString()) + "</span>";
      } else {
        return "" + title + "<span class='j2hvalue'>&nbsp;&nbsp;-instance object, can't render-</span>";
      }
    } else {
      return "" + title + "<span class='j2hvalue'>&nbsp;&nbsp;" + data + "</span>";
    }
  } else {
    title = makeLabelDiv(options, level, name, 'object');
    count = 0;
    subs = "<div>" + ((function() {
      var _results;
      _results = [];
      for (key in data) {
        _results.push(render(key, data[key], options, level + 1, count++ % 2));
      }
      return _results;
    })()).join("</div><div>") + "</div>";
    inner = "<div class=\"j2hexpand clearfix " + altrow + "\">\n	" + title + "\n	<div class=\"" + contentClass + "\">" + subs + "</div>\n</div>";
    return "" + (level === 0 ? '<div id=\'j2h\'>' : '') + "\n	" + inner + "\n" + (level === 0 ? '</div>' : '');
  }
};

exports.render = function(json, options) {
  return "" + head + (render(null, json, options, 0, 0));
};

head = '<style type="text/css">\n#j2h table {\n	border-collapse:collapse;\n}\n#j2h th {\n	color: #888 ;\n}\n#j2h table,#j2h th, #j2h td {\n	border: 1px solid #DDD;\n	padding: 10px 5px ;\n}\n#j2h th, #j2h td {\n	text-align:center;\n}\n#j2h .content {\n	padding-left: 30px ;\n	font-family: Arial ;\n}\n\n#j2h .index {\n	font-size: 100% ;\n	color: #999 ;\n	float: left ;\n}\n#j2h  .clearfix:after {\n	content: ".";\n  display: block;\n  height: 0;\n  clear: both;\n  visibility: hidden;\n}\n#j2h  .j2hlabel {\n	font-family: Helvetica Neue ;\n	color: #333 ;\n}\n#j2h  .j2hvalue {\n	font-family: Arial ;\n	color: #777 ;\n}\n#j2h .collapsible > .j2hlabel:hover {\n	text-decoration: underline;\n}\n#j2h .collapsible > .j2hlabel {\n	color: #15C;\n}\n#j2h  .j2hcollapse > div.content {\n	display: none ;\n}\n#j2h  .j2hcollapse > .j2hlabel {\n	font-weight: bold ;\n}\n\n#j2h .j2hexpand  > div > .j2hlabel, #j2h .j2hcollapse  > div > .j2hlabel {\n	background-repeat:no-repeat;\n	background-position:left;\n	padding-left: 25px ;\n	margin: 5px 0px 5px 15px ;\n	display: inline-block ;\n}\n\n#j2h .j2hexpand  > div > .j2hlabel {\n	background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAD8GlDQ1BJQ0MgUHJvZmlsZQAAKJGNVd1v21QUP4lvXKQWP6Cxjg4Vi69VU1u5GxqtxgZJk6XpQhq5zdgqpMl1bhpT1za2021Vn/YCbwz4A4CyBx6QeEIaDMT2su0BtElTQRXVJKQ9dNpAaJP2gqpwrq9Tu13GuJGvfznndz7v0TVAx1ea45hJGWDe8l01n5GPn5iWO1YhCc9BJ/RAp6Z7TrpcLgIuxoVH1sNfIcHeNwfa6/9zdVappwMknkJsVz19HvFpgJSpO64PIN5G+fAp30Hc8TziHS4miFhheJbjLMMzHB8POFPqKGKWi6TXtSriJcT9MzH5bAzzHIK1I08t6hq6zHpRdu2aYdJYuk9Q/881bzZa8Xrx6fLmJo/iu4/VXnfH1BB/rmu5ScQvI77m+BkmfxXxvcZcJY14L0DymZp7pML5yTcW61PvIN6JuGr4halQvmjNlCa4bXJ5zj6qhpxrujeKPYMXEd+q00KR5yNAlWZzrF+Ie+uNsdC/MO4tTOZafhbroyXuR3Df08bLiHsQf+ja6gTPWVimZl7l/oUrjl8OcxDWLbNU5D6JRL2gxkDu16fGuC054OMhclsyXTOOFEL+kmMGs4i5kfNuQ62EnBuam8tzP+Q+tSqhz9SuqpZlvR1EfBiOJTSgYMMM7jpYsAEyqJCHDL4dcFFTAwNMlFDUUpQYiadhDmXteeWAw3HEmA2s15k1RmnP4RHuhBybdBOF7MfnICmSQ2SYjIBM3iRvkcMki9IRcnDTthyLz2Ld2fTzPjTQK+Mdg8y5nkZfFO+se9LQr3/09xZr+5GcaSufeAfAww60mAPx+q8u/bAr8rFCLrx7s+vqEkw8qb+p26n11Aruq6m1iJH6PbWGv1VIY25mkNE8PkaQhxfLIF7DZXx80HD/A3l2jLclYs061xNpWCfoB6WHJTjbH0mV35Q/lRXlC+W8cndbl9t2SfhU+Fb4UfhO+F74GWThknBZ+Em4InwjXIyd1ePnY/Psg3pb1TJNu15TMKWMtFt6ScpKL0ivSMXIn9QtDUlj0h7U7N48t3i8eC0GnMC91dX2sTivgloDTgUVeEGHLTizbf5Da9JLhkhh29QOs1luMcScmBXTIIt7xRFxSBxnuJWfuAd1I7jntkyd/pgKaIwVr3MgmDo2q8x6IdB5QH162mcX7ajtnHGN2bov71OU1+U0fqqoXLD0wX5ZM005UHmySz3qLtDqILDvIL+iH6jB9y2x83ok898GOPQX3lk3Itl0A+BrD6D7tUjWh3fis58BXDigN9yF8M5PJH4B8Gr79/F/XRm8m241mw/wvur4BGDj42bzn+Vmc+NL9L8GcMn8F1kAcXjEKMJAAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAvUlEQVQokcXSsQqDMBAG4DM5dNEIR8ic0c0XyEv0DfoKPlEfQ1fJ0t2lu0snt87XpRYbG0Gh9CAEcnw/B7mEmeFoicPyZ5iISq31hYjKXZiISkTs8zw/I2IfC1jhGapC1VmWgSpUHQsQMShRAgCARBkNEFswTdP7VoCIQWNMNwzDyRjThQEfeJqmh7V2XELvfQMAV+99swyw1o7vuZl5PpVzrnXOtcxcLd6jvSRYz+p13778zKoX4l31v91+Aia/VebVEqkCAAAAAElFTkSuQmCC) ;\n}\n\n#j2h .j2hcollapse > div > .j2hlabel {\n	background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAD8GlDQ1BJQ0MgUHJvZmlsZQAAKJGNVd1v21QUP4lvXKQWP6Cxjg4Vi69VU1u5GxqtxgZJk6XpQhq5zdgqpMl1bhpT1za2021Vn/YCbwz4A4CyBx6QeEIaDMT2su0BtElTQRXVJKQ9dNpAaJP2gqpwrq9Tu13GuJGvfznndz7v0TVAx1ea45hJGWDe8l01n5GPn5iWO1YhCc9BJ/RAp6Z7TrpcLgIuxoVH1sNfIcHeNwfa6/9zdVappwMknkJsVz19HvFpgJSpO64PIN5G+fAp30Hc8TziHS4miFhheJbjLMMzHB8POFPqKGKWi6TXtSriJcT9MzH5bAzzHIK1I08t6hq6zHpRdu2aYdJYuk9Q/881bzZa8Xrx6fLmJo/iu4/VXnfH1BB/rmu5ScQvI77m+BkmfxXxvcZcJY14L0DymZp7pML5yTcW61PvIN6JuGr4halQvmjNlCa4bXJ5zj6qhpxrujeKPYMXEd+q00KR5yNAlWZzrF+Ie+uNsdC/MO4tTOZafhbroyXuR3Df08bLiHsQf+ja6gTPWVimZl7l/oUrjl8OcxDWLbNU5D6JRL2gxkDu16fGuC054OMhclsyXTOOFEL+kmMGs4i5kfNuQ62EnBuam8tzP+Q+tSqhz9SuqpZlvR1EfBiOJTSgYMMM7jpYsAEyqJCHDL4dcFFTAwNMlFDUUpQYiadhDmXteeWAw3HEmA2s15k1RmnP4RHuhBybdBOF7MfnICmSQ2SYjIBM3iRvkcMki9IRcnDTthyLz2Ld2fTzPjTQK+Mdg8y5nkZfFO+se9LQr3/09xZr+5GcaSufeAfAww60mAPx+q8u/bAr8rFCLrx7s+vqEkw8qb+p26n11Aruq6m1iJH6PbWGv1VIY25mkNE8PkaQhxfLIF7DZXx80HD/A3l2jLclYs061xNpWCfoB6WHJTjbH0mV35Q/lRXlC+W8cndbl9t2SfhU+Fb4UfhO+F74GWThknBZ+Em4InwjXIyd1ePnY/Psg3pb1TJNu15TMKWMtFt6ScpKL0ivSMXIn9QtDUlj0h7U7N48t3i8eC0GnMC91dX2sTivgloDTgUVeEGHLTizbf5Da9JLhkhh29QOs1luMcScmBXTIIt7xRFxSBxnuJWfuAd1I7jntkyd/pgKaIwVr3MgmDo2q8x6IdB5QH162mcX7ajtnHGN2bov71OU1+U0fqqoXLD0wX5ZM005UHmySz3qLtDqILDvIL+iH6jB9y2x83ok898GOPQX3lk3Itl0A+BrD6D7tUjWh3fis58BXDigN9yF8M5PJH4B8Gr79/F/XRm8m241mw/wvur4BGDj42bzn+Vmc+NL9L8GcMn8F1kAcXjEKMJAAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAy0lEQVQokcXSQQqDMBAF0J8SDIRAQeYIknWWXbjwKHbppeIxeoAcQ6EXEHfdFaabRixNFKTQgUBg/htmMYKZcbROh+VPMRH1RNSngqmeXDeNMe37j2marns9CQBlWZ6J6CKEiPk2hiJUSgEAiqK4fKw9z/PDe99prUcAUErBGNMS0X0Ntdaj975b9mbm+GQIoXHODdZattZyVVUc/865IYTQMLOMZo2TA3Iwhb8G5GAOLwPqur7lIDNDbJynBFABGAE8U4EtvFv/u+0XXc3BmKS0o/MAAAAASUVORK5CYII=);\n}\n\n#j2h .j2hcollapse > span.collapsible:before {\n	border-radius: 2px;\n	border-color: #A44;\n	border-style: solid;\n	border-width: 1px;\n	color: #A44;\n	content: \'+\';\n	display: inline-block;\n	line-height: 7px;\n	margin: 0 2px;\n	overflow: hidden;\n	padding: 1px;\n	font-size: 11px ;\n}\n\n#j2h .j2hexpand > span.collapsible:before {\n	border: none ;\n	color: #A44;\n	content: \'-\';\n	display: inline-block;\n	line-height: 7px;\n	margin: 4px;\n	overflow: hidden;\n	padding: 1px;\n	font-size: 11px ;\n}\n\n#j2h.level0 {\n	font-size: 25px ;\n}\n#j2h  .level1 {\n	font-size: 22px ;\n}\n\n\n#j2h .leaf {\n	color: #666;\n	display: inline ;\n}\n\n#j2h .altRows:nth-child(odd)    { background-color:#ddd; }\n#j2h .altRows:nth-child(even)    { background-color:#fff; }\n\n#j2h tr:nth-child(odd)    { background-color:#eee; }\n#j2h tr:nth-child(even)    { background-color:#fff; }\n\n\n</style>\n<script type=text/javascript>\n	j2h = {\n		toggleVisibility: function(el, name) {\n			j2h.toggleClass(el.parentElement,\'j2hcollapse j2hexpand\') ;\n		},\n		classRe: function(name) {\n			return new RegExp(\'(?:^|\\\\s)\'+name+\'(?!\\\\S)\') ;\n		},\n		addClass: function(el, name) {\n			el.className += " "+name;\n		},\n		removeClass: function(el, name) {\n			var re = j2h.classRe(name) ;\n			el.className  = el.className.replace( j2h.classRe(name) , \'\' )\n		},\n		hasClass: function(el, name) {\n			var re = j2h.classRe(name) ;\n			return j2h.classRe(name).exec(el.className);\n		},\n		toggleClass: function(el, name) {\n			var names = name.split(/\\s+/) ;\n			for (n in names) {\n				if (j2h.hasClass(el, names[n])) {\n					j2h.removeClass(el, names[n]) ;\n				} else {\n					j2h.addClass(el, names[n]) ;\n				}\n			}\n		}\n	};\n</script>';



//////////////////
// WEBPACK FOOTER
// ./~/json2html/lib/json2html.js
// module id = 902
// module chunks = 0